<!-- O BusPositions recebe detalhes da paragem do componente pai e mostra um mapa com a localização da paragem e autocarros. -->

<template>
  <div class="buspositions-container">
    <div class="map-container">
      <RealColourMap
        :bus-stop-number="busStopNumber"
        :bus-stop-latitude="busStopLatitude"
        :bus-stop-longitude="busStopLongitude"
        :busPositions="busPositions"
        :routeColors="routeColors"
      />
    </div>
  </div>
</template>

<script>
import RealColourMap from './realColourMap.vue';
import { getBusPositions } from '@/services/api.js';
import { debugMode } from '@/config/config.js';

export default {
  name: 'BusPositions',

  inject: ['logDebug'],

  components: {
    RealColourMap,
  },

  props: {
    painelId: {
      type: String,
      required: false,
      default: null,
    },
    busPositionsInterval: {
      type: Number,
      required: true,
    },
    busStopNumber: {
      type: String,
      required: true,
    },
    busStopLatitude: {
      type: Number,
      required: true,
    },
    busStopLongitude: {
      type: Number,
      required: true,
    },
    routeColors: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      busPositions: [],
      errorMessage: '',
      isLoading: true,
      refreshInterval: null,
      isFetching: false,
      lastConfig: null,
    };
  },
  watch: {
    busPositionsInterval(newVal, oldVal) {
      if (debugMode) console.log('BusPositionsInterval mudou:', newVal);

      if (newVal !== oldVal) {
        clearInterval(this.refreshInterval);
        this.setBusPositionsInterval();
      }
    },
  },

  mounted() {
    this.setBusPositionsInterval();
  },

  beforeUnmount() {
    clearInterval(this.refreshInterval);
  },

  methods: {
    async fetchBusPositions() {
      if (this.isFetching) return;
      this.isFetching = true;
      this.isLoading = true;
      this.logDebug('fetchBusPositions para a paragem ' + this.busStopNumber);

      try {
        const response = await getBusPositions(this.busStopNumber, this.painelId);
        if (debugMode) console.log('Posição dos autocarros foi recebida:', response);

        this.busPositions = response;
        this.errorMessage = '';
      } catch (error) {
        console.error(error);
        this.errorMessage = 'Falha ao carregar as posições autocarros. Por favor, aguarde.';
        this.logDebug('fetchBusPositions: ' + error, 'error');
      } finally {
        this.isLoading = false;
        this.isFetching = false;
      }
    },

    async setBusPositionsInterval() {
      try {
        this.fetchBusPositions();
        const intervalValue = this.busPositionsInterval ? parseInt(this.busPositionsInterval, 10) : 60000;
        if (debugMode) {
          console.log('Intervalo de BusPositions recebido:', intervalValue);
          this.logDebug('Intervalo de BusPositions recebido: ' + intervalValue);
        }
        this.refreshInterval = setInterval(this.fetchBusPositions, intervalValue);
      } catch (error) {
        console.error('Erro ao buscar o intervalo de BusPositions:', error);
        this.logDebug('Erro ao buscar o intervalo de BusPositions: ' + error);
      }
    },
  },

  computed: {
    isLoadingBusStop() {
      return this.isLoading;
    },
  },
};
</script>

<style>
/* Alturas explícitas — 648px (756 do body direito - 108 do header amarelo) */
.buspositions-container {
  height: 648px;
  width: 960px;
  margin: 0;
  padding: 0;
}

.map-container {
  height: 648px;
  width: 960px;
}

.error-image {
  max-width: 100%;
  max-height: 300px;
  width: auto;
  height: auto;
  margin: 0 auto;
  display: block;
}
</style>
